/* eslint-disable no-eval */
import { GetObjectCommand, S3 } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { toast } from "react-toastify";
import * as faceapi from "face-api.js";
import { renderToStaticMarkup } from "react-dom/server";
const CryptoJS = require("crypto-js");

export const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result);
        };

        fileReader.onerror = (error) => {
            reject(error);
        }
    })
}
export const currentMonth = () => new Date().toLocaleString("en-US", { month: "2-digit" });
export const currentYear = () => new Date().toLocaleString("en-US", { year: "numeric" });

export const ConvertDate = (date) => {
    if (!date) return "N/A";
    var con_date = date?.split('-');
    return `${con_date?.[2]} ${month[+con_date?.[1] - 1]} ${con_date?.[0]}`;
}

export const DateConvertInDbFormat = (date = new Date()) => {
     return `${date?.getFullYear()}-${(date?.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date?.getDate()?.toString()?.padStart(2, "0")}`;
}

export const revertDateFormat = (dateStr) => {
  if (!dateStr) return "N/A";
  const parts = dateStr?.split("-");
  if (parts.length === 3) {
    const [year, month, day] = parts;
    return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
  }
  return dateStr;
}
export const ConvertDateTime = (date) => {
    if (!date) return "N/A";
    var con_date = date?.split('T')?.[0]?.split('-');
    return `${con_date?.[2]} ${month[+con_date?.[1] - 1]} ${con_date?.[0]}`;
}
export const ConvertTime = (date, showDate = false) => {
    if (!date) return "-";
    const dateTime = new Date(date);

    const formattedTime = dateTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
        timeZone: "UTC",
    });
    if (!showDate) {
        return formattedTime;
    }

    const day = String(dateTime.getUTCDate()).padStart(2, "0");
    const monthName = month[dateTime.getUTCMonth()];
    const year = dateTime.getUTCFullYear();

    return `${day} ${monthName} ${year}, ${formattedTime}`;
};

// seconds to hr-min
export const formatTimeDuration = (totalSeconds) => {
     if (
        totalSeconds === null ||
        totalSeconds === undefined ||
        totalSeconds === "" ||
        isNaN(Number(totalSeconds))
    ) {
        return "-";
    }
    const seconds = Math.floor(Number(totalSeconds));

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    // const remainingSeconds = seconds % 60;

    return `${hours} hrs ${minutes} mins`;
};

export const ConvertTimeOnly = (time) => {
    if (!time) return "—";  // Handle empty values
    let [hours, minutes] = time.split(":");
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 24-hour format to 12-hour
    return `${hours}:${minutes} ${ampm}`;
};


export const getUserData = () => {
    if (sessionStorage.getItem("userData")) {
        var userData = CryptoJS.AES.decrypt(sessionStorage.getItem("userData"), 'userData');
        return JSON.parse(userData.toString(CryptoJS.enc.Utf8));
    }
}
export const getUserId = () =>{
    const data = getUserData();
    return data?.emp_users_fk ? +data?.emp_users_fk : +data?.emp_users_pk;
}
export const getDomain = () =>{
    const data = getUserData();
    return data?.domain
}
export const getEmployeeId = () =>{
    const data = getUserData();
    return +data?.employee_id
}
export const getAtsUserId = () =>{
    const data = getUserData();
    return +data?.ats_user_id
}
export const isAdminOwner = () => {
    const data = getUserData();
    return (
        data?.core_hr_user_type === "Owner" ||
        data?.core_hr_user_type === "Admin"
        )
}
export const checkPayrollAccess = () => {
    const userData = getUserData();
    if (
        userData?.enable_payroll && (userData?.enable_payroll_executive || userData?.enable_finance_executive)
        && (userData?.f_country_code === "IND")) {
        return true;
    } else {
        return false;
    }
}

export const handleGroupby = (xs, key) => {
    return xs?.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const handleSearch = (search, data, field) => {
    /**
    * Dynamic Live Search in the array
    * some() executes the function once for each element in the array
    */
    const keyword = (search);
    if (field) {
        const fil = data.filter(res =>
            eval('res.' + field + '.toLowerCase().includes(keyword.toLowerCase())')
        )
        return fil;
    } else {
        const filtered = data.filter(
            entry => Object.values(entry).some(val =>
                typeof val === "string" &&
                (val.toLowerCase()).includes(keyword.toLowerCase())
            )
        );
        return filtered;
    }
};

export const handleSort = (data, field, order) => {
    /**
    * Dynamic Live Sort in the array
    */
    function compareObjects(object1, object2, key) {
        const obj1 = object1[key].toUpperCase()
        const obj2 = object2[key].toUpperCase()

        if (order === "asc") {
            if (obj1 < obj2) return -1
            if (obj1 > obj2) return 1
            return 0
        } else {
            if (obj1 > obj2) return -1
            if (obj1 < obj2) return 1
            return 0
        }
    }

    return data.sort((a, b) => {
        return compareObjects(a, b, field)
    })
};


export const s3Client = new S3({
    // forcePathStyle: false, // Configures to use subdomain/virtual calling format.
    endpoint: process.env.REACT_APP_DO_ENDPOINT,
    region: process.env.REACT_APP_DO_REGION,
    credentials: {
        accessKeyId: process.env.REACT_APP_DO_SPACES_KEY,
        secretAccessKey: process.env.REACT_APP_DO_SPACES_SECRET
    }
});

export const DownloadAttachment = async (filename, customName) => {
    const bucketParams = {
        Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
        Key: filename,
        ...(customName && {
            ResponseContentDisposition: `attachment; filename="${customName}"`
        })
    };
    try {
        const ext = filename.split('.').pop().toLowerCase();
        const url = await getSignedUrl(s3Client, new GetObjectCommand(bucketParams), { expiresIn: 3 * 60 }); // Adjustable expiration.
        if (ext === 'doc' || ext === 'docx') {
            window.open(`https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`, "_blank");
        } else {
            if (customName) {
                try {
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = blobUrl;
                    a.download = customName;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(blobUrl);
                } catch (e) {
                    window.open(url, "_blank");
                }
            } else {
                window.open(url, "_blank");
            }
        }
        return url;
    } catch (err) {
        toast.error(err)
    }
};
 export const getImageSignedUrl = async (filename) => {
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 604800 }
      );
      return url;
    } catch (err) {
      toast.error(err);
    }
  };
export const formatPayPeriod = (payDay) => {
    if (!payDay || payDay < 1) return ''; // Handle invalid cases
    const suffix = (day) => {
        if (day % 10 === 1 && day !== 11) return 'ˢᵗ';
        if (day % 10 === 2 && day !== 12) return 'ⁿᵈ';
        if (day % 10 === 3 && day !== 13) return 'ʳᵈ';
        return 'ᵗʰ';
    };
    if (payDay === 1) return `1ˢᵗ to 31ˢᵗ`; // Handle first day case

    return `${payDay}${suffix(payDay)} to ${(payDay - 1)}${suffix(payDay - 1)}`;
};
export const formatPayDatePeriod = (paydate) => {
    if (!paydate?.start_date || !paydate?.end_date) return '';
    const getFormattedDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();

        const suffix = (d) => {
            if (d % 10 === 1 && d !== 11) return 'ˢᵗ';
            if (d % 10 === 2 && d !== 12) return 'ⁿᵈ';
            if (d % 10 === 3 && d !== 13) return 'ʳᵈ';
            return 'ᵗʰ';
        };

        return `${day}${suffix(day)} ${month} ${year}`;
    };
    const startFormatted = getFormattedDate(paydate.start_date);
    const endFormatted = getFormattedDate(paydate.end_date);
    return `${startFormatted} to ${endFormatted}`;
};

let modelsLoaded = false;

export async function loadFaceApiModels() {
  if (!modelsLoaded) {
    const MODEL_URL = process.env.PUBLIC_URL + "/models";
    await Promise.all([
      faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL),
      faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL),
      faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL),
      faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
    ]);
    modelsLoaded = true;
  }
}

export function reactSvgToBase64(SvgComponent) {
  const svgString = renderToStaticMarkup(<SvgComponent />);
  const encoded = window.btoa(
    unescape(encodeURIComponent(svgString))
  );
  return `data:image/svg+xml;base64,${encoded}`;
}

export const toWordsDynamic = (num) => {
  const n = Math.floor(Number(String(num || 0).replace(/,/g, "")) || 0);
  if (n === 0) return "Zero";

  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const convert = (val) => {
    if (val < 20) return ones[val];
    if (val < 100) return tens[Math.floor(val / 10)] + (val % 10 !== 0 ? " " + ones[val % 10] : "");
    if (val < 1000) return ones[Math.floor(val / 100)] + " Hundred" + (val % 100 !== 0 ? " " + convert(val % 100) : "");
    if (val < 100000) return convert(Math.floor(val / 1000)) + " Thousand" + (val % 1000 !== 0 ? " " + convert(val % 1000) : "");
    if (val < 10000000) return convert(Math.floor(val / 100000)) + " Lakh" + (val % 100000 !== 0 ? " " + convert(val % 100000) : "");
    return convert(Math.floor(val / 10000000)) + " Crore" + (val % 10000000 !== 0 ? " " + convert(val % 10000000) : "");
  };

  return convert(n);
};

export const formatAmountInWords = (amount) => {
  const n = Math.floor(Number(String(amount || 0).replace(/,/g, "")) || 0);
  if (!n) return "";
  return `${toWordsDynamic(n)} Only`;
};